<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit" href="javascript:void(0);" class="small" @click="openFullEdit()">
          <AppIcon icon="box-arrow-up-right" class="mr-1"></AppIcon>
          Ver ficha completa
        </b-link>
      </b-col>

      <!-- MODO + NOMBRE -->
      <b-col md="5">
        <b-form-group label="Modo *" label-size="sm">
          <b-form-select v-model="form.mode" :options="modeOptions" size="sm" :disabled="loading" @change="onModeChange" />
        </b-form-group>
      </b-col>

      <b-col md="7">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name" size="sm" placeholder="Nombre del proyecto"
                        ref="inputName" :disabled="loading" />
        </b-form-group>
      </b-col>

      <!-- CLIENTE -->
      <b-col md="12">
        <b-form-group label="Cliente *" label-size="sm">
          <b-form-select v-model="form.customer_id" :options="options.customers" size="sm" :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Seleccionar cliente —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <!-- FECHAS -->
      <b-col md="6">
        <b-form-group label="Fecha de inicio" label-size="sm">
          <b-form-datepicker v-model="form.date_init" size="sm" placeholder="Seleccionar" local="es" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="6" v-if="form.mode === 'with_expiration'">
        <b-form-group label="Fecha de fin *" label-size="sm"
                      :state="dateState" :invalid-feedback="dateFeedback">
          <b-form-datepicker v-model="form.date_end" size="sm" placeholder="Seleccionar" local="es"
                             :disabled="loading" :state="dateState" />
        </b-form-group>
      </b-col>

      <!-- HORAS ESTIMADAS (solo con vto) -->
      <b-col md="6" v-if="form.mode === 'with_expiration'">
        <b-form-group label="Horas estimadas" label-size="sm">
          <b-form-input v-model="form.hours_estimated" type="number" size="sm" min="0" step="0.01" :disabled="loading" />
        </b-form-group>
      </b-col>

      <!-- HORAS POR MES (solo sin vto) -->
      <b-col md="6" v-if="form.mode === 'without_expiration'">
        <b-form-group label="Horas incluidas por mes" label-size="sm">
          <b-form-input v-model="form.monthly_hours_included" type="number" size="sm" min="0" step="0.01" :disabled="loading" />
        </b-form-group>
      </b-col>

      <!-- PROJECT MANAGER -->
      <b-col md="12">
        <b-form-group label="Project Manager" label-size="sm">
          <b-form-select v-model="form.employee_id" :options="options.employees" size="sm" :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Sin asignar —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <!-- DESCRIPCION -->
      <b-col md="12">
        <b-form-group label="Descripción" label-size="sm">
          <app-textarea v-model="form.description" size="sm" rows="2"
                           placeholder="Alcance del proyecto (opcional)" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="dark" size="sm" @click="save()" :disabled="loading || !canSave">
          <AppIcon icon="check" class="mr-1"></AppIcon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  const emptyForm = () => ({
    name: '',
    mode: 'with_expiration',
    status: 'active',
    customer_id: 0,
    date_init: '',
    date_end: '',
    hours_estimated: 0,
    monthly_hours_included: 0,
    employee_id: 0,
    description: '',
    equipo: [],
    services_invoice_id: 0,
    observations: '',
  })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return {
        form: emptyForm(),
        loading: false,
        options: { customers: [], employees: [] },
        modeOptions: [
          { value: 'with_expiration', text: 'Con vencimiento' },
          { value: 'without_expiration', text: 'Sin vencimiento' },
        ],
      }
    },
    computed: {
      dateState() {
        if (this.form.mode !== 'with_expiration') return null
        if (!this.form.date_init || !this.form.date_end) return null
        return this.form.date_end >= this.form.date_init ? null : false
      },
      dateFeedback() {
        return 'La fecha de fin debe ser posterior a la de inicio'
      },
      canSave() {
        if (!this.form.name.trim()) return false
        if (!this.form.customer_id) return false
        if (this.form.mode === 'with_expiration' && this.dateState === false) return false
        return true
      },
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) { this.loadForEdit(val.id) } else { this.form = emptyForm() }
        },
      },
    },
    mounted() {
      this.loadOptions()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadOptions() {
        serviceAPI.obtenerListaClientes().then((r) => {
          this.options.customers = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
        serviceAPI.obtenerListaEmpleados().then((r) => {
          this.options.employees = r.data.filter((x) => x.active).map((x) => ({ value: x.id, text: x.name }))
        })
      },
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerProyecto(id)
          .then((r) => {
            var d = r.data
            this.form = Object.assign(emptyForm(), d)
            this.form.name = this.form.name || ''
            this.form.mode = this.form.mode || 'with_expiration'
            this.form.status = this.form.status || 'active'
            this.form.customer_id = this.form.customer_id || 0
            this.form.date_init = this.form.date_init || ''
            this.form.date_end = this.form.date_end || ''
            this.form.hours_estimated = this.form.hours_estimated || 0
            this.form.monthly_hours_included = this.form.monthly_hours_included || 0
            this.form.employee_id = this.form.employee_id || 0
            this.form.description = this.form.description || ''
            this.form.equipo = Array.isArray(this.form.equipo) ? this.form.equipo : (this.form.equipo ? this.form.equipo.split(',') : [])
            this.form.services_invoice_id = this.form.services_invoice_id || 0
            this.form.observations = this.form.observations || ''
          })
          .finally(() => { this.loading = false })
      },
      onModeChange() {
        if (this.form.mode === 'without_expiration') {
          this.form.date_end = ''
          this.form.hours_estimated = 0
        } else {
          this.form.monthly_hours_included = 0
        }
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        window.open(this.$router.resolve({ name: this.viewEdit, params: params }).href, '_blank')
      },
      save() {
        if (!this.canSave) return
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          mode: this.form.mode,
          customer_id: this.form.customer_id,
          date_init: this.form.date_init,
          date_end: this.form.date_end,
          hours_estimated: this.form.hours_estimated,
          monthly_hours_included: this.form.monthly_hours_included,
          employee_id: this.form.employee_id,
          description: this.form.description,
        })
        var call = isEdit
          ? serviceAPI.editarProyecto(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarProyecto(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Proyecto actualizado' : 'Proyecto creado')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar el proyecto') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
